module.exports = __webpack_public_path__ + "media/CN_012.ec50cab1.mp3";